// extracted by mini-css-extract-plugin
export var base = "Footer-module--base--14136";
export var blurb = "Footer-module--blurb--ba433";
export var brand = "Footer-module--brand--1d22b";
export var brandBlock = "Footer-module--brandBlock--f1b94";
export var column = "Footer-module--column--aa0eb";
export var columnTitle = "Footer-module--columnTitle--80130";
export var footer = "Footer-module--footer--afd90";
export var grid = "Footer-module--grid--339ae";
export var links = "Footer-module--links--34636";
export var mark = "Footer-module--mark--bf7cc";
export var note = "Footer-module--note--7205e";